export default __webpack_public_path__ + "static/media/ni.6d4d3ab8.svg";